export enum TelemetryGenericEnum {
  EMPTY_VALUE = '',
  DEFAULT_STATUS_CODE = 600,
  DEFAULT_FAILURE = 'Failure',
  DEFAULT_ALERT = 'Alert',
  NO_VALUE_ERROR_MSG = 'No value',
  UNKNOWN_BACKEND_ERROR = 'Unknown backend error. Your request could not be processed properly.',
  CHECK_IN_ERROR_PAGE = 'checkin:error',
  INTERACTION_EVENT_TYPE = 'interaction',
  INLINE_ERROR = 'checkin:errorMessage:inlineError',
}
